import axios from '../api' // 倒入 api\

//获取油箱列表
const getOilBoxMessage = (data) => {
    return axios({
      url: '/api/tank/list',
      method: 'POST',
      data
    })
  }

//新增油箱
const addOilBox = (data) => {
    return axios({
      url: `/api/tank`,
      method: 'POST',
      data
    })
  }

//修改油箱
const modifyOilBox = (data) => {
    return axios({
      url: `/api/tank`,
      method: 'PUT',
      data
    })
  }

//获取油箱信息
const getOilBoxDetail = (tankId) => {
    return axios({
      url: `/api/tank/${tankId}`,
      method: 'GET',
    })
  }

//删除油箱
const delOilBox = (tankId) => {
    return axios({
      url: `/api/tank/${tankId}`,
      method: 'DELETE',
    })
  }


//获取传感器列表
const getSensorMessage = (data) => {
    return axios({
      url: '/api/sensor/list',
      method: 'POST',
      data
    })
  }

//新增传感器
const addSensor = (data) => {
    return axios({
      url: `/api/sensor`,
      method: 'POST',
      data
    })
  }

//修改传感器
const modifySensor = (data) => {
    return axios({
      url: `/api/sensor`,
      method: 'PUT',
      data
    })
  }

//获取传感器信息
const getSensorDetail = (sensorId) => {
    return axios({
      url: `/api/sensor/${sensorId}`,
      method: 'GET',
    })
  }

//删除传感器
const delSensor = (sensorId) => {
    return axios({
      url: `/api/sensor/${sensorId}`,
      method: 'DELETE',
    })
  }

//获取油箱设置列表
const getOilBoxSetting = (data) => {
  return axios({
    url: '/api/oil/manage/list',
    method: 'POST',
    data
  })
}

//获取参数参考对象
const getRefer = () => {
  return axios({
    url: `/api/oil/manage/refer`,
    method: 'GET',
  })
}

//设置油箱
const setOilBox = (data) => {
  return axios({
    url:`/api/oil/manage`,
    method: 'POST',
    data
  })
}

//获取油箱下拉列表
const oilBoxList = () => {
  return axios({
    url:`/api/tank/list`,
    method:'GET',
  })
}

//获取传感器下拉列表
const oilSensorList = () => {
  return axios({
    url:`/api/sensor/list`,
    method:'GET',
  })
}

//获取油箱设置详情
const getTankSetDetail = (carId) => {
  return axios({
    url: `/api/oil/manage/${carId}`,
    method: 'GET',
  })
}

//获取标定信息
const getStandardDetail = (carTankSensorId) => {
  return axios({
    url: `/api/standard/${carTankSensorId}`,
    method:'GET',
  })
}

//修改标定
const modifyStandard = (carTankSensorId,data) => {
  return axios({
    url: `/api/standard/${carTankSensorId}`,
    method: 'PUT',
    data
  })
}

//获取油量数据
const getOilChartData = (data) => {
  return axios({
    url: `/api/report/oil/chart`,
    method: 'POST',
    data
  })
}

//下发参数
const getCommand = (carTankSensorId) => {
  return axios({
    url: `/api/oil/manage/command/${carTankSensorId}`,
    method: 'GET'
  })
}

//接触绑定
const delBind = (carTankSensorId) => {
  return axios({
    url: `/api/oli/manage/${carTankSensorId}`,
    method: 'DELETE',
  })
}

//计算油箱理论体积
const tankCalculate = (data) => {
  return axios({
    url: `/api/tank/calculate`,
    method: 'POST',
    data
  })
}

//获取加油记录
const getAddOilReport = (data) => {
  return axios({
    url:`/api/report/addoil`,
    method: 'POST',
    data
  })
}

//获取漏油记录
const getLeakOilReport = (data) => {
  return axios({
    url:`/api/report/oilLeakage`,
    method: 'POST',
    data
  })
}

//获取全部油量记录
const getOilReport = (data) => {
  return axios({
    url:`/api/report/oil`,
    method: 'POST',
    data
  })
}

//获取加油记录tab
const getAddOilTab = (data) => {
  return axios({
    url:`/api/device/addoil`,
    method: 'POST',
    data
  })
}

//获取漏油记录tab
const getLeakOilTab = (data) => {
  return axios({
    url:`/api/device/oilLeakage`,
    method: 'POST',
    data
  })
}

//计算标定
const calculate = (params) => {
  return axios({
    url:`/api/standard/calculate`,
    method: `GET`,
    params
  })
}

//获取绑定设备的车辆列表
const getoilCarList = () => {
  return axios({
    url: `/api/car/oil/simple`,
    method: 'GET',
  })
}

//查看当前油箱液位高度与油量值
const getTankCurrent = (params) => {
  return axios({
    url:`/api/tank/current`,
    method:'GET',
    params
  })
}

//修正下发
const modifyStandardCommand = (carTankSensorId,data) => {
  return axios({
    url:`/api/standard/modify/${carTankSensorId}`,
    method:'PUT',
    data
  })
}

//获取加油历史图表数据
const addoilHistoryData = (params) => {
  return axios({
    url:`/api/addoil/history`,
    method:'GET',
    params
  })
}

export default {
    getOilBoxMessage,
    addOilBox,
    getOilBoxDetail,
    modifyOilBox,
    delOilBox,
    getSensorMessage,
    addSensor,
    modifySensor,
    getSensorDetail,
    delSensor,
    getOilBoxSetting,
    getRefer,
    setOilBox,
    oilBoxList,
    oilSensorList,
    getTankSetDetail,
    getStandardDetail,
    modifyStandard,
    getOilChartData,
    getCommand,
    delBind,
    tankCalculate,
    getAddOilReport,
    getLeakOilReport,
    getAddOilTab,
    getLeakOilTab,
    calculate,
    getOilReport,
    getoilCarList,
    getTankCurrent,
    modifyStandardCommand,
    addoilHistoryData
}